import { Routes, Route } from "react-router-dom";
import DomainExtensionsListPage from "./list";
import AddDomainExtensionPage from "./add";
import EditDomainExtensionPage from "./edit";
import ViewDomainExtensionPage from "./view";

function DomainExtensionsPage() {
	return (
		<Routes>
			<Route index element={<DomainExtensionsListPage />} />
			<Route path="/:id" element={<ViewDomainExtensionPage />} />
			<Route path="/add" element={<AddDomainExtensionPage />} />
			<Route path="/:id/edit" element={<EditDomainExtensionPage />} />
		</Routes>
	);
}

export default DomainExtensionsPage;
